<template>
  <div class="mt-4" v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Boletim de Ocorrência</h3>
      </div>
      <div>
        <div class="vx-row mt-4">
          <!-- Data Registro BO -->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
            <label class="vs-input--label">Data Registro BO</label>
            <div class="inputData">
              <flat-pickr
                :config="configdateTimePickerDay"
                v-model="formBoletimOcorrencia.dataBoletim"
                placeholder="DD/MM/AAAA"
                name="Data Registro BO"
              />
            </div>
          </div>

          <!-- Hora Registro BO -->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
            <label class="vs-input--label">Hora Registro BO</label>
            <div class="inputData">
              <flat-pickr
                :config="configdateTimePickerHour"
                v-model="formBoletimOcorrencia.horaBoletim"
                placeholder="HH:MM"
                name="Hora Registro BO"
              />
            </div>
          </div>

          <!-- Dias após o fato -->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Dias após o fato"
              name="Dias após o fato"
              v-model="nrDias"
              disabled="true"
            />
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- Elaboração do BO Presencial? -->
          <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
            <label class="vs-input--label">Elaboração do BO Presencial?</label>
            <vs-switch
              v-model="formBoletimOcorrencia.boletimPresencial"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- BO Online? -->
          <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
            <label class="vs-input--label">BO Online?</label>
            <vs-switch
              v-model="formBoletimOcorrencia.boletimOnline"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Houve vítima? -->
          <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
            <label class="vs-input--label">Houve vítima?</label>
            <vs-switch
              v-model="formBoletimOcorrencia.possuiVitima"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Monta -->
          <div class="vx-col xl:w-1/2 w-full mb-2">
            <label class="vs-select--label">Monta</label>
            <v-select
              :options="listMonta"
              name="Monta"
              id="Monta"
              v-model="formBoletimOcorrencia.idMonta"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>

        <div class="vx-row mt-4">
          <div class="vx-col w-full">
            <vs-textarea
              label="Relato do Boletim de Ocorrência"
              v-model="formBoletimOcorrencia.descricaoBoletim"
            />
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import vSelect from 'vue-select';
import moment from 'moment';

import dateConversion from '../../../../../utils/dateConversion';
import functions from '../../../../../utils/functions';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (
        value.dadosEventos &&
        value.dadosEventos.dataEvento &&
        value.dadosEventos.horaEvento
      ) {
        this.dataHoraEvento = `${dateConversion.convertDateToISO(
          value.dadosEventos.dataEvento,
        )} ${value.dadosEventos.horaEvento}`;
      }

      if (!value.boletimOcorrencia) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - BOLETIM OCORRENCIA FORM');
        return;
      }

      this.formBoletimOcorrencia = Object.assign(
        this.formBoletimOcorrencia,
        value.boletimOcorrencia,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.boletimOcorrencia = this.formBoletimOcorrencia;
    },
  },
  components: {
    flatPickr,
    vSelect,
  },
  data() {
    return {
      showComponent: true,
      dataHoraEvento: null,
      formBoletimOcorrencia: {
        dataBoletim: null,
        horaBoletim: null,
        boletimPresencial: null,
        boletimOnline: null,
        possuiVitima: null,
        idMonta: null,
        descricaoBoletim: null,
      },

      listMonta: [],

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
    };
  },
  computed: {
    nrDias() {
      if (
        !this.dataHoraEvento ||
        !this.formBoletimOcorrencia.dataBoletim ||
        !this.formBoletimOcorrencia.horaBoletim
      ) {
        return '';
      }

      const auxDataHoraBoletim = `${dateConversion.convertDateToISO(
        this.formBoletimOcorrencia.dataBoletim,
      )} ${this.formBoletimOcorrencia.horaBoletim}`;

      const ms = moment(auxDataHoraBoletim).diff(this.dataHoraEvento);

      return functions.formataMsParaData(ms);
    },
  },
  mounted() {
    if (!this.formData.boletimOcorrencia) {
      console.error('ERRO NO CONTRATO DO OBJETO - BOLETIM OCORRENCIA FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.boletimOcorrencia = this.formBoletimOcorrencia;

    if (this.dominios) {
      this.listMonta = this.dominios.listMonta;
    }
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}

input.flatpickr-input {
  width: 100%;
}
</style>
